<div class="mt-5">
  <div class="flex items-center border border-dc-navy overflow-hidden">
    <button type="button" class="px-2 text-dc-navy">
      <i class="fas fa-search"></i>
    </button>
    <input
      type="text"
      class="flex-grow px-4 py-2 text-sm focus:outline-none"
      [value]="searchText"
      (input)="handleSearch($event)"
    />
  </div>

  <div
    class="flex justify-end items-center text-sm font-semibold text-dc-navy mt-3"
  >
    @if (searchText) {
      <button class="text-dc-navy hover:underline" (click)="clearSearch()">
        {{ "CLEAR" | translate }}
      </button>
    }
  </div>

  @if (results.length > 0) {
    <ul class="divide-y divide-gray-200 text-dc-navy">
      @for (item of results; track $index) {
        <li
          class="flex justify-between py-3 cursor-pointer"
          (click)="navigateTo(item)"
        >
          <span class="font-semibold">{{ displayLabel(item) }}</span>
          @if (displayCategory(item)) {
            <span class="text-dc-navy text-sm">
              {{ displayCategory(item) }}
            </span>
          }
        </li>
      }
    </ul>
  }
</div>
